import { Alert, Box, Button, Grid2, Typography } from "@mui/material";
import { FormEvent, useState } from "react";
import { ValidatorForm } from 'react-material-ui-form-validator';
import { redirect } from "react-router";
import { Link } from "react-router-dom";
import { StandardTextValidator } from "../../_components/textValidator/standardTextValidator";
import { toastr } from "../../_components/toastr/toastr";
import { accountService } from "../../_services/accounts.service";
import { authScreenStyles } from "../../_styles/authScreen.styles";
import { AuthLogo } from "./_components/authLogo";
import { StandardButton } from "../../_components/button/primary.button";
import { BrandEnum } from "../../_common/enum/brand.enum";


export function LoginForgotPassword(params: { brand: BrandEnum }) {
    const [email, setEmail] = useState("");
    const [isEmailReset, resetEmail] = useState(false);
    const [isLoading, setLoading] = useState(false);

    if (accountService.currentUserValue) {
        redirect('/');
    }

    function submit(e: FormEvent) {
        e.preventDefault();
        setLoading(true);

        accountService.forgotPassword(email)
            .then(
                (item => { resetEmail(true); }),
                ((err) => {
                    toastr.error("Something went wrong. Please try again later");
                }))
            .finally(() => {
                setLoading(false);
            });
    }


    return (
        <>
            <AuthLogo brand={params.brand} />

            <Typography sx={authScreenStyles.subheading}>
                Enter your email to reset your password
            </Typography>

            {isEmailReset === true && (
                <Alert severity="success" sx={authScreenStyles.alert}>
                    Please check your email and click on the provided link to reset your password.
                </Alert>
            )}

            {isEmailReset !== true && (
                <ValidatorForm onSubmit={submit} noValidate style={authScreenStyles.form}>
                    <Grid2 container spacing={2} sx={authScreenStyles.formContainer}>
                        <Grid2 size={{ xs: 12 }}>
                            <Alert severity="warning" style={authScreenStyles.alert}>
                                Please enter your email address to request a password reset.
                            </Alert>
                        </Grid2>

                        <Grid2 size={{ xs: 12 }}>
                            <StandardTextValidator
                                required
                                fullWidth
                                label="Email"
                                name="email"
                                value={email}
                                disabled={isLoading}
                                onChange={(e: any) => setEmail(e.target.value.toString())}
                                validators={["required", "isEmail"]}
                                errorMessages={["This field is required", "Email is not valid"]}
                                autoFocus
                            />
                        </Grid2>

                        <Grid2 size={{ xs: 12 }}>
                            <StandardButton
                                type="submit"
                                variant="primary"
                                loading={isLoading}
                                icon={"lock_reset"}>
                                Request Password Reset
                            </StandardButton>
                        </Grid2>
                    </Grid2>
                </ValidatorForm>
            )}

            <Box sx={authScreenStyles.linkContainer}>
                <Link style={authScreenStyles.link} to="/login">
                    Back to Log In
                </Link>
            </Box>

        </>
    );
}